import { useTokenExFrame } from "@insite/client-framework/Common/Hooks/useTokenExFrame";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import validateCreditCard from "@insite/client-framework/Common/Utilities/validateCreditCard";
import { HasOnError } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getPaymentProfiles, GetPaymentProfilesApiParameter } from "@insite/client-framework/Services/AccountService";
import { TokenExConfig } from "@insite/client-framework/Services/SettingsService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadPaymetricConfig from "@insite/client-framework/Store/Context/Handlers/LoadPaymetricConfig";
import loadTokenExConfig from "@insite/client-framework/Store/Context/Handlers/LoadTokenExConfig";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import resetCurrentCartId from "@insite/client-framework/Store/Data/Carts/Handlers/ResetCurrentCartId";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadPaymentProfiles from "@insite/client-framework/Store/Data/PaymentProfiles/Handlers/LoadPaymentProfiles";
import updatePaymentProfile from "@insite/client-framework/Store/Data/PaymentProfiles/Handlers/UpdatePaymentProfile";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import checkoutWithPayPal from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/CheckoutWithPayPal";
import getPaymetricResponsePacket from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/GetPaymetricResponsePacket";
import placeOrder from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import preloadOrderConfirmationData from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/PreloadOrderConfirmationData";
import translate from "@insite/client-framework/Translate";
import { AccountPaymentProfileModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ECheckDetailsEntry, {
    Validatable,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ECheckDetailsEntry";
import Button from "@insite/mobius/Button";
import Checkbox, {  } from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import Link, {  } from "@insite/mobius/Link";
import Modal from "@insite/mobius/Modal";
import Select from "@insite/mobius/Select";
import { TextAreaProps } from "@insite/mobius/TextArea";
import TextField from "@insite/mobius/TextField/TextField";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import { generateTokenExFrameStyleConfig } from "@insite/mobius/TokenExFrame";
import Typography, {  } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import EditIcon from "@MasterBluePrint/Icons/EditIcon";
import InfoNewIcon from "@MasterBluePrint/Icons/InfoNew";
import WarningNotification from "@MasterBluePrint/Icons/WarningNotification";
import { CheckoutReviewAndSubmitPageContext } from "@MasterBluePrint/Overrides/Pages/CheckoutReviewAndSubmitPage"
import CheckoutReviewAndSubmitCarrierService from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import CheckoutReviewAndSubmitProductList from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList"
import CreditCardBillingAddressEntry from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
import CreditCardDetailsEntry from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import PaymentProfileBillingAddress from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress";
import PayPalButton from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/PayPalButton";
import SavedPaymentProfileEntry from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import SavedPaymentsCardListReviewAndPay from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/SavedPaymentsCardListReviewAndPay";
import SavedPaymentsReviewAndPay from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/SavedPaymentsReviewAndPay";
import WirePaymentEntry from "@MasterBluePrint/Widgets/CheckoutReviewAndSubmit/WirePaymentEntry";
import React, { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { ThemeProps, withTheme } from "styled-components";

import { getCookie } from "@insite/client-framework/Common/Cookies";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import ShippingTermsConsentModal from "@MasterBluePrint/Components/ShippingTermsConsentModal";
import { validateNonUSKeyBoardCharacters } from "@MasterBluePrint/Overrides/Common/Utilities/validateNonUSKeyBoardCharacters";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/checkoutReviewAndSubmitPaymentDetailsStyles";
import { COOKIE_KEYS } from "@MasterBluePrint/Common/Utilities/CookieKeys";
import { LaunchDarklyFlagKeys } from "@MasterBluePrint/Common/Utilities/LaunchDarklyFlagKeys";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";
import checkoutReviewAndPayTracking from "@MasterBluePrint/Tracking/CheckoutReviewAndPay/checkoutReviewAndPayTracking";

const enum fields {
    taxExemptHeaderText = "taxExemptHeaderText",
    taxExemptFooterText = "taxExemptFooterText",
    alreadyTaxExempt = "alreadyTaxExempt",
    taxNotExempt = "taxNotExempt",
    checkboxFieldValue = "checkboxFieldValue",
    txtBankName = "txtBankName",
    txtBankAddress = "txtBankAddress",
    txtBankPhone = "txtBankPhone",
    txtBankContactName = "txtBankContactName",
    txtBankContactEmail = "txtBankContactEmail",
    txtBankAccountName = "txtBankAccountName",
    txtBankAccountNumber = "txtBankAccountNumber",
    txtBankSwift = "txtBankSwift",
    txtBankARBRounting = "txtBankARBRounting",
    txtBankCurrency = "txtBankCurrency",
    txtTaxIDNumber = "txtTaxIDNumber",
    txtAccountReceivableContactName = "txtAccountReceivableContactName",
    txtAccountReceivableContactPhone = "txtAccountReceivableContactPhone",
    txtAccountReceivableContactEmail = "txtAccountReceivableContactEmail",
    txtAccountReceivableContactACHEmailRemittance = "txtAccountReceivableContactACHEmailRemittance",
}
const parameter: GetPaymentProfilesApiParameter = { pageSize: 999 };
interface OwnProps extends WidgetProps {
    fields: {
        [fields.taxExemptHeaderText]: string;
        [fields.taxExemptFooterText]: string;
        [fields.alreadyTaxExempt]: string;
        [fields.taxNotExempt]: string;
        [fields.checkboxFieldValue]: boolean;
        [fields.txtBankName]: string;
        [fields.txtBankAddress]: string;
        [fields.txtBankPhone]: string;
        [fields.txtBankContactName]: string;
        [fields.txtBankContactEmail]: string;
        [fields.txtBankAccountName]: string;
        [fields.txtBankAccountNumber]: string;
        [fields.txtBankSwift]: string;
        [fields.txtBankARBRounting]: string;
        [fields.txtBankCurrency]: string;
        [fields.txtTaxIDNumber]: string;
        [fields.txtAccountReceivableContactName]: string;
        [fields.txtAccountReceivableContactPhone]: string;
        [fields.txtAccountReceivableContactEmail]: string;
        [fields.txtAccountReceivableContactACHEmailRemittance]: string;
    };
}

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    properties: { [key: string]: string };
    notes?: string;
    taxExemptionMessage?: string;
    attentionMessage?: string;
    payerId: string;
    maskedCardNumber: string;
}
const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const settingsCollection = getSettingsCollection(state);
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const currencyCode = state.context.session.currency?.currencyCode ?? "";
    return {
        cartState,
        billToState: getBillToState(state, cartState.value ? cartState.value.billToId : undefined),
        countries: getCurrentCountries(state),
        websiteSettings: settingsCollection.websiteSettings,
        cartSettings: settingsCollection.cartSettings,
        tokenExConfigs: state.context.tokenExConfigs,
        orderConfirmationPageLink: getPageLinkByPageType(state, "OrderConfirmationPage"),
        savedPaymentsPageLink: getPageLinkByPageType(state, "SavedPaymentsPage"),
        session: state.context.session,
        signInPageLink: getPageLinkByPageType(state, "SignInPage"),
        checkoutReviewAndSubmitPageLink: getPageLinkByPageType(state, "CheckoutReviewAndSubmitPage"),
        payPalRedirectUri: state.pages.checkoutReviewAndSubmit.payPalRedirectUri,
        location: getLocation(state),
        usePaymetricGateway: settingsCollection.websiteSettings.usePaymetricGateway,
        paymetricConfig: state.context.paymetricConfig,
        enableVat: settingsCollection.productSettings.enableVat,
        fields: ownProps.fields,
        shipToState: getShipToState(state, cartState.value?.shipToId),
        notes: cart?.notes,
        shipToAddressFields: getAddressFieldsDataView(state).value?.shipToAddressFields,
        currentUserIsGuest: getCurrentUserIsGuest(state),
        currencyCode,
        isLoading: cartState.isLoading,
    };
};

const mapDispatchToProps = {
    loadTokenExConfig,
    placeOrder,
    checkoutWithPayPal,
    preloadOrderConfirmationData,
    loadBillTo,
    loadPaymetricConfig,
    getPaymetricResponsePacket,
    loadPaymentProfiles,
    loadCurrentCart,
    updatePaymentProfile,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasHistory &
    HasToasterContext &
    TextAreaProps;


// TokenEx doesn't provide an npm package or type definitions for using the iframe solution.
// This is just enough types to avoid the build warnings and make using TokenEx a bit easier.
export type TokenExIframeStyles = {
    base?: string;
    focus?: string;
    error?: string;
    cvv?: TokenExIframeStyles;
};

export type TokenExIframeConfig = {
    tokenExID: string;
    tokenScheme: string;
    authenticationKey: string;
    timestamp: string;
    origin: string;
    styles?: TokenExIframeStyles;
    pci?: boolean;
    enableValidateOnBlur?: boolean;
    inputType?: "number" | "tel" | "text";
    debug?: boolean;
    cvv?: boolean;
    cvvOnly?: boolean;
    cvvContainerID?: string;
    cvvInputType?: "number" | "tel" | "text";
};

type TokenExPCIIframeConfig = TokenExIframeConfig & {
    pci: true;
    enablePrettyFormat?: boolean;
};

type TokenExCvvOnlyIframeConfig = TokenExIframeConfig & {
    cvvOnly: true;
    token?: string;
    cardType?: string;
};

export type IFrame = {
    new(containerId: string, config: TokenExIframeConfig): IFrame;
    load: () => void;
    on: (
        eventName: "load" | "validate" | "tokenize" | "error" | "cardTypeChange",
        callback: (data: any) => void,
    ) => void;
    remove: () => void;
    validate: () => void;
    tokenize: () => void;
    reset: () => void;
};

export type TokenEx = {
    Iframe: IFrame;
};

declare const TokenEx: TokenEx;
let tokenExIframe: IFrame | undefined;
let tokenExAccountNumberIframe: IFrame | undefined;

let tokenExFrameStyleConfig: TokenExIframeStyles;

declare function $XIFrame(options: any): any;
let paymetricIframe: any;
const isNonEmptyString = (value: string | undefined) => value !== undefined && value.trim() !== "";
let isTaxCertificateAvailableOnCustomer = false;

const isMonthAndYearBeforeToday = (month: number, year: number) => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    return year < currentYear || (year === currentYear && month < currentMonth + 1);
};

const convertTokenExCardTypeToApiData = (cardType: string) => {
    if (cardType.includes("american")) {
        return "AMERICAN EXPRESS";
    }

    return cardType.toUpperCase();
};

const convertApiDataToTokenExCardType = (cardType: string) => {
    const loweredCardType = cardType.toLowerCase();

    if (loweredCardType === "mastercard") {
        return "masterCard";
    }
    if (loweredCardType === "american express") {
        return "americanExpress";
    }

    return loweredCardType;
};

const convertPaymetricCardType = (cardType: string) => {
    switch (cardType.toLowerCase()) {
        case "vi":
            return "Visa";
        case "mc":
            return "MasterCard";
        case "ax":
            return "American Express";
        case "dc":
            return "Diner's";
        case "di":
            return "Discover";
        case "jc":
            return "JCB";
        case "sw":
            return "Maestro";
        default:
            return "unknown";
    }
};

const styles = checkoutReviewAndSubmitPaymentDetailsStyles;
const StyledForm = getStyledWrapper("form");
const StyledFieldSet = getStyledWrapper("fieldset");

const CheckoutReviewAndSubmitPaymentDetails = ({
    loadBillTo,
    cartState,
    billToState,
    countries,
    websiteSettings,
    cartSettings,
    tokenExConfigs,
    placeOrder,
    orderConfirmationPageLink,
    savedPaymentsPageLink,
    history,
    checkoutWithPayPal,
    payPalRedirectUri,
    preloadOrderConfirmationData,
    loadTokenExConfig,
    theme,
    session,
    checkoutReviewAndSubmitPageLink,
    location,
    toaster,
    paymetricConfig,
    loadPaymetricConfig,
    usePaymetricGateway,
    getPaymetricResponsePacket,
    enableVat,
    fields,
    shipToState,
    loadPaymentProfiles,
    shipToAddressFields,
    currentUserIsGuest,
    loadCurrentCart,
    currencyCode,
    updatePaymentProfile,
    isLoading
}: Props) => {
    const [paymentMethod, setPaymentMethod] = useState("");
    const [poNumber, setPONumber] = useState("");
    const [vatNumber, setVatNumber] = useState("");
    const [saveCard, setSaveCard] = useState(false);
    const [cardHolderName, setCardHolderName] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [cardType, setCardType] = useState("");
    const [possibleCardType, setPossibleCardType] = useState("");
    const [expirationMonth, setExpirationMonth] = useState(1);
    const [expirationYear, setExpirationYear] = useState(new Date().getFullYear());
    const [securityCode, setSecurityCode] = useState("");
    const [useBillingAddress, setUseBillingAddress] = useState(true);
    const [address1, setAddress1] = useState("");
    const [countryId, setCountryId] = useState("");
    const [stateId, setStateId] = useState("");
    const [city, setCity] = useState("");
    const [postalCode, setPostalCode] = useState("");

    const [paymentMethodError, setPaymentMethodError] = useState("");
    const [poNumberError, setPONumberError] = useState("");
    const [cardHolderNameError, setCardHolderNameError] = useState("");
    const [cardNumberError, setCardNumberError] = useState("");
    const [cardTypeError, setCardTypeError] = useState("");
    const [securityCodeError, setSecurityCodeError] = useState("");
    const [expirationError, setExpirationError] = useState("");
    const [address1Error, setAddress1Error] = useState("");
    const [countryError, setCountryError] = useState("");
    const [stateError, setStateError] = useState("");
    const [cityError, setCityError] = useState("");
    const [postalCodeError, setPostalCodeError] = useState("");
    const [payPalError, setPayPalError] = useState("");

    const [showFormErrors, setShowFormErrors] = useState(false);
    const [isCardNumberTokenized, setIsCardNumberTokenized] = useState(false);
    const [isTokenExIframeLoaded, setIsTokenExIframeLoaded] = useState(false);
    const [isECheckTokenized, setIsECheckTokenized] = useState(false);
    const [accountHolderName, setAccountHolderName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [routingNumber, setRoutingNumber] = useState("");

    // Used in deciding which form element to focus on in the case the form is submitted with errors
    const paymentMethodRef = useRef<HTMLSelectElement>(null);
    const poNumberRef = useRef<HTMLInputElement>(null);
    const cardHolderNameRef = useRef<HTMLInputElement>(null);
    const cardNumberRef = useRef<HTMLInputElement>(null);
    const cardTypeRef = useRef<HTMLSelectElement>(null);
    const securityCodeRef = useRef<HTMLInputElement>(null);
    const expirationMonthRef = useRef<HTMLSelectElement>(null);
    const expirationYearRef = useRef<HTMLSelectElement>(null);
    const address1Ref = useRef<HTMLInputElement>(null);
    const countryRef = useRef<HTMLSelectElement>(null);
    const stateRef = useRef<HTMLSelectElement>(null);
    const cityRef = useRef<HTMLInputElement>(null);
    const postalCodeRef = useRef<HTMLInputElement>(null);
    const collectNumberRef = useRef<HTMLInputElement>(null);
    const taxExemptCodeNumberRef = useRef<HTMLInputElement>(null);
    const [collectNumber, setCollectNumber] = useState("");
    const isNonEmptyString = (value: string | undefined) => value !== undefined && value.trim() !== "";
    const [collectNumberError, setCollectNumberError] = useState("");
    const [taxExemptionNumberError, setTaxExemptionNumberError] = useState("");
    const [taxCodeNumber, setTaxCodeNumber] = useState("");
    // const [canValidatetaxCodeNumber, setTaxCodeNumber] = useState("");
    // Used in validation of form, since some form elements will not be validated when PayPal is active.
    const [isPayPal, setIsPayPal] = useState(false);
    const [isWirePayment, setIsWirePayment] = useState(false);
    // Help to work in the flow of React to validate the form.
    // Since setting isPayPal and validating will not have the correct "effect" in place to correctly validate the form.
    const [runSubmitPayPal, setRunSubmitPayPal] = useState(false);
    const [taxExempt, setTaxExempt] = useState("No");
    const [taxExemptBool, setTaxExemptBool] = useState(false);
    const [isTaxExempionNumber, setIsTaxExempionNumber] = useState(false);
    const [taxExemptDisabled, setTaxExemptDisabled] = useState(false);
    const [notes, setOrderNote] = useState("");

    const [taxExemptionMessage, setTaxExemptionMessage] = useState("");
    const [attentionMessage, setAttentionMessage] = useState("");
    const [showText, setShowText] = React.useState(false);
    const Net30PaymentText = siteMessage("Net30_tooltip").toString();
    const [rememberMe, setRememberMe] = useState(false);
    const [selectSavedCard, setselectSavedCard] = useState(true);
    const [addNewCard, setAddNewCardForm] = useState(false);
    const [editCard, setEditCardForm] = useState(false);

    const [selectPaymentProfile, setSelectPaymentProfile] = useState<AccountPaymentProfileModel | null>();
    const [openCartModel, setCardModalOpen] = useState(false);
    const [shippingState, setshippingState] = useState(false);
    const [maskedCardNumber, setMaskedCardNumber] = useState("");
    const [notesError, setNotesError] = useState("");
    const orderNotesValidationMessage = siteMessage('Non_English_Keyboard_Characters_Validation_Message')?.toString();
    const featureFlags: string[] = [LaunchDarklyFlagKeys.TEUS_8308];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const isShippingTermsEnabled = flagValues[LaunchDarklyFlagKeys.TEUS_8308];

    // Function to update booleanValue
    const updateShippingComponentState = (value: any) => {
        setshippingState(value);
    };



    const cardSelectorModalCloseHandler = React.useCallback((event: any) => {
        loadCurrentCart({ shouldLoadFullCart: true, replaceCart: true, getCartLines: true });
        setCardModalOpen(false);
        showCardList();
    }, []);
    const useAsDefaultClickHandler = (paymentProfile: AccountPaymentProfileModel) => {
        const paymentProfileToUpdate = { ...paymentProfile, isDefault: true };
        updatePaymentProfile({
            paymentProfile: paymentProfileToUpdate,
            onSuccess: () => {
                // toasterContext.addToast({ body: translate("Default Card Updated"), messageType: "success" });

            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.();

                }
            },
        });

        cardSelectorModalCloseHandler(false);
        setPaymentMethod(paymentProfile.cardIdentifier);

    };
    const selectCreditCardHandler = React.useCallback((event: any) => {
        setSelectPaymentProfile(event);
        // setPaymentMethod(event.cardIdentifier);
        // Set the credit card as a payment method here
    }, []);

    const cardEditSelectorModalCloseHandler = React.useCallback((event: any) => {
        loadCurrentCart({ shouldLoadFullCart: true, replaceCart: true, getCartLines: true });
        setCardModalOpen(true);
        showCardList();
    }, []);
    const selectCollectNumberDataHandler = React.useCallback((event: any) => {
        setCollectNumber(event);
    }, []);
    const collectOrderNotesDataHandler = React.useCallback((event: any) => {
        setOrderNote(event);
    }, []);
    const showCardList = () => {
        setAddNewCardForm(false);
        setselectSavedCard(true);
        setEditCardForm(false);
    };

    const showNewCardForm = () => {
        setselectSavedCard(false);
        setAddNewCardForm(true);
    };
    const showNewOrEditCardForm = () => {
        showNewCardForm();
        setEditCardForm(true);
    };

    const [savedPaymentProfile, setSavedPaymentProfile] = useState<AccountPaymentProfileModel>();
    // will exist after we are redirected back here from paypal

    const [isCreditCardMethod, setCreditCardMethod] = useState<boolean | undefined>();
    useEffect(() => {
        if (paymentMethod) {
            const checkCreditCard = paymentMethods?.find(method => method.name === paymentMethod);
            setCreditCardMethod(checkCreditCard?.isCreditCard);
        }
    }, [paymentMethod]);

    const {
        PayerID: payPalPayerId,
        token: payPalToken,
        cartId,
    } = parseQueryString<{
        PayerID?: string;
        token?: string;
        cartId?: string;
    }>(location.search);

    const [isActive, setIsActive] = useState("");

    const resetForm = () => {
        setCardHolderNameError("");
        setCardNumberError("");
        setCardTypeError("");
        setExpirationError("");
        setSecurityCodeError("");
        setAddress1("");
        setCountryError("");
        setStateError("");
        setCityError("");
        setPostalCodeError("");
        setPayPalError("");
        setIsCardNumberTokenized(false);
        setIsTokenExIframeLoaded(false);
        // setTaxExempt("No");
    };

    useEffect(() => {
        if (!billToState.value && !billToState.isLoading && cartState.value && cartState.value.billToId) {
            loadBillTo({ billToId: cartState.value.billToId });
        }
        if (billToState?.value?.id === shipToState?.value?.id && billToState?.value?.attention !== "") {
            setAttentionMessage(`Attention: ${billToState?.value?.attention} | `);
        } else if (shipToState?.value?.attention !== "") {
            setAttentionMessage(`Attention: ${shipToState?.value?.attention} | `);
        }
    }, [billToState]);

    useTokenExFrame();

    useEffect(() => resetForm(), [paymentMethod]);

    useEffect(() => {
        if (isCardNumberTokenized || isECheckTokenized) {
            const props = {
                ...cart?.properties,
                customerFreightBillingAcctNumber: collectNumber,
                taxExemptionNumber: taxExempt === "Yes" ? taxCodeNumber : "",
            };
            if (cart?.promotionCode !== "" && cart?.promotionCode !== null) {
                prependPromotionCodeToNotes();
            }
            placeOrder({
                paymentMethod,
                poNumber,
                vatNumber,
                saveCard,
                cardHolderName,
                cardNumber,
                cardType,
                expirationMonth,
                expirationYear,
                securityCode,
                useBillingAddress,
                address1,
                countryId,
                stateId,
                city,
                postalCode,
                payPalToken,
                payPalPayerId,
                accountHolderName,
                accountNumber,
                routingNumber,
                properties: props || {},
                notes,
                taxExemptionMessage,
                attentionMessage,
                payerId: "",
                maskedCardNumber,
                onSuccess: (cartId: string) => {
                    if (!orderConfirmationPageLink) {
                        return;
                    }
                    if(cart != null){
                        checkoutReviewAndPayTracking(cart)
                    }
                    if (cart?.isAwaitingApproval) {
                        resetCurrentCartId({});
                        toaster.addToast({
                            body: siteMessage("OrderApproval_OrderPlaced"),
                            messageType: "success",
                        });
                    }

                    history.push(`${orderConfirmationPageLink.url}?cartId=${cartId}`);
                },
                onError: () => {
                    setIsCardNumberTokenized(false);
                    tokenExIframe?.reset();
                },
                onComplete(resultProps: any) {
                    if (resultProps.apiResult?.cart) {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onSuccess?.(resultProps.apiResult.cart.id);
                    } else {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onError?.();
                    }
                },
            } as PlaceOrderParameter & HasOnError);
        }
    }, [isCardNumberTokenized, isECheckTokenized]);

    useEffect(() => {

        if (!cartState.isLoading && cartState.value && cartState.value.paymentMethod && paymentMethod === "") {
            setPaymentMethod(cartState.value.paymentMethod.name);
            if (cartState.value.paymentMethod.name === "94") {
                setIsWirePayment(true);
            }
            else {
                setIsWirePayment(false);
            }
        }

    }, [cartState.isLoading]);

    // IsPayPal
    // Setup isPayPal from cart.paymentOptions and validates form when cartState changes and is loaded.
    useEffect(() => {
        if (cartState.value) {
            const tempIsPayPal = cartState.value.paymentOptions?.isPayPal || !!payPalToken;
            setIsPayPal(tempIsPayPal);
            if (tempIsPayPal) {
                validateForm();
            }
        }
    }, [cartState]);

    // Submit PayPal
    // When isPayPal and runSubmitPayPal are true will validate form, and submitPayPal with the current page redirectUri and current cart.
    useEffect(() => {
        if (isPayPal && runSubmitPayPal) {
            if (!validateForm()) {
                setShowFormErrors(true);
                return;
            }
            if (!checkoutReviewAndSubmitPageLink) {
                return;
            }
            let redirectUri = `${window.location.host}${checkoutReviewAndSubmitPageLink.url}`;
            if (cartId) {
                redirectUri += `?cartId=${cartId}`;
            }
            checkoutWithPayPal({ redirectUri });
        }
    }, [runSubmitPayPal, isPayPal]);

    // Submit PayPal State Check
    // Handles the PayPal button click response, getting the payPal redirectUri from the server on cart update call.
    useEffect(() => {
        if (payPalRedirectUri) {
            window.location.href = payPalRedirectUri;
        }
    }, [payPalRedirectUri]);
    const { value: cart } = cartState;
    const { useTokenExGateway, useECheckTokenExGateway } = websiteSettings;
    const { showPayPal } = cartSettings;
    const paymentOptions = cart ? cart.paymentOptions : undefined;
    const paymentMethods = paymentOptions ? paymentOptions.paymentMethods : undefined;
    const paymentMethodDto = paymentMethods?.find(method => method.name === paymentMethod);
    const selectedCountry = countries?.find(country => country.id === countryId);
    let tokenName: string | undefined;
    const eCheckDetails = useRef<Validatable>(null);
    const [paymentProfiles, setPaymentProfiles] = React.useState<AccountPaymentProfileModel | null>();
    const [modalOpen, setModalOpen] = useState(false);
    if (useTokenExGateway) {
        if (paymentMethodDto?.isPaymentProfile) {
            tokenName = paymentMethodDto.name;
        } else if (paymentMethodDto?.isCreditCard) {
            tokenName = "";
        }
    }

    if (useECheckTokenExGateway) {
        if (paymentMethodDto?.isECheck) {
            tokenName = "";
        }
    }

    useEffect(() => {
        if (paymentMethods && paymentMethods.length > 0 && (paymentMethod === "" || (paymentMethod === "94" && !paymentMethods.some(p => p.name === "94")))) {
            // if wire payment was previously selected and now it is not in payment methods because country is changed to US
            if (paymentMethod === "94" && !paymentMethods.some(p => p.name === "94")) {
                setIsWirePayment(false);
            }
            paymentMethods.forEach(method => {
                if (method.cardType === null && method.description !== "Net 30" && method.name === '17') {
                    setIsActive(method.name);
                    setPaymentMethod(method.name);
                    validatePaymentMethod(method.name);
                }
            })
        }
    }, [paymentMethods]);
    useEffect(() => {
        loadCurrentCart({ shouldLoadFullCart: true, replaceCart: true, getCartLines: true });
        if (typeof tokenName !== "undefined") {
            const isECheck = paymentMethodDto?.isECheck === true;
            loadTokenExConfig({ token: tokenName, isECheck });
        }
    }, [paymentMethod]);

    const tokenExConfig = typeof tokenName !== "undefined" ? tokenExConfigs[tokenName] : undefined;
    useEffect(() => {
        if (!isLoading) {
            if (cart?.totalTax === 0) {
                setTaxExempt("Yes");
                setTaxExemptDisabled(true);
            } else {
                setTaxExempt("No");
                setTaxExemptDisabled(false);
            }
        }
    }, [cart, isLoading]);

    useEffect(() => {
        if (cart?.paymentMethod && paymentMethod === "") {
            setIsActive(cart.paymentMethod.name);
            setPaymentMethod(cart.paymentMethod.name);
            validatePaymentMethod(cart.paymentMethod.name);
        }
        else if (paymentMethods && paymentMethods.length > 0 && paymentMethod === "") {
            paymentMethods.forEach(method => {
                if (method.cardType === null && method.name === '17') {
                    setIsActive(method.name);
                    setPaymentMethod(method.name);
                    validatePaymentMethod(method.name);
                }
            })
        }
        const taxExcemptionCode1 = cart?.properties?.taxExcemptionCode1;
        if (taxExcemptionCode1) {
            isTaxCertificateAvailableOnCustomer = true;
        }
    }, [cart]);
    useEffect(() => {
        if (typeof TokenEx === "undefined" || !tokenExConfig) {
            return;
        }

        setIsTokenExIframeLoaded(false);
        setUpTokenEx();
    }, [tokenExConfig, typeof TokenEx]);


    useEffect(() => {
        const listener = (event: any) => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                event.preventDefault();
            }
        };
        document.addEventListener("keydown", listener);
        return () => {
            document.removeEventListener("keydown", listener);
        };
    }, []);

    const setUpTokenEx = () => {
        if (!tokenExConfig || !paymentMethodDto) {
            return;
        }

        if (paymentMethodDto.isPaymentProfile && !paymentMethodDto.isPaymentProfileExpired) {
            setUpTokenExIFrameCvvOnly(tokenExConfig);
        } else if (paymentMethodDto.isCreditCard) {
            setUpTokenExIFrame(tokenExConfig);
        }
    };

    const setUpTokenExIFrame = (config: TokenExConfig) => {
        if (tokenExIframe) {
            tokenExIframe.remove();
        }

        const iframeConfig: TokenExPCIIframeConfig = {
            authenticationKey: config.authenticationKey,
            cvv: true,
            cvvContainerID: "tokenExSecurityCode",
            cvvInputType: "text",
            enablePrettyFormat: true,
            inputType: "text",
            origin: config.origin,
            pci: true,
            styles: tokenExFrameStyleConfig,
            timestamp: config.timestamp,
            tokenExID: config.tokenExId,
            tokenScheme: config.tokenScheme,
        };

        tokenExIframe = new TokenEx.Iframe("tokenExCardNumber", iframeConfig);
        tokenExIframe.load();
        tokenExIframe.on("load", _ => setIsTokenExIframeLoaded(true));
        tokenExIframe.on("tokenize", data => {
            setCardNumber(data.token);
            setSecurityCode("CVV");
            setCardType(convertTokenExCardTypeToApiData(data.cardType));
            setIsCardNumberTokenized(true);
        });
        tokenExIframe.on("cardTypeChange", data => setPossibleCardType(data.possibleCardType));
        tokenExIframe.on("validate", data => {
            setShowFormErrors(true);
            if (data.isValid) {
                setCardNumberError("");
            } else {
                if (data.validator === "required") {
                    setCardNumberError(translate("Credit card number is required."));
                }
                if (data.validator === "format") {
                    setCardNumberError(translate("Credit card number is invalid."));
                }
            }

            if (data.isCvvValid) {
                setSecurityCodeError("");
            } else {
                if (data.cvvValidator === "required") {
                    setSecurityCodeError(translate("Security code is required."));
                }
                if (data.cvvValidator === "format") {
                    setSecurityCodeError(translate("Security code is invalid."));
                }
            }
        });
        tokenExIframe.on("error", data => {
            logger.error(data);
            setUpTokenExIFrame(config);
        });
    };

    const setUpTokenExIFrameCvvOnly = (config: TokenExConfig) => {
        if (tokenExIframe) {
            tokenExIframe.remove();
        }

        const iframeConfig: TokenExCvvOnlyIframeConfig = {
            authenticationKey: config.authenticationKey,
            cardType: convertApiDataToTokenExCardType(paymentMethodDto!.cardType),
            cvv: true,
            cvvOnly: true,
            inputType: "text",
            origin: config.origin,
            styles: tokenExFrameStyleConfig,
            timestamp: config.timestamp,
            token: paymentMethodDto!.name,
            tokenExID: config.tokenExId,
            tokenScheme: paymentMethodDto!.tokenScheme,
        };

        tokenExIframe = new TokenEx.Iframe("ppTokenExSecurityCode", iframeConfig);
        tokenExIframe.load();
        tokenExIframe.on("load", _ => setIsTokenExIframeLoaded(true));
        tokenExIframe.on("tokenize", _ => setIsCardNumberTokenized(true));
        tokenExIframe.on("validate", data => {
            if (data.isValid) {
                setSecurityCodeError("");
            } else {
                setShowFormErrors(true);
                if (data.validator === "required") {
                    setSecurityCodeError(translate("Security code is required."));
                }
                if (data.validator === "format") {
                    setSecurityCodeError(translate("Security code is invalid."));
                }
            }
        });
        tokenExIframe.on("error", data => {
            logger.error(data);
            setUpTokenExIFrameCvvOnly(config);
        });
    };

    const paymetricFrameRef = useRef<HTMLIFrameElement>(null);
    const setupPaymetricIframe = () => {
        if (!paymetricConfig) {
            return;
        }
        paymetricIframe = $XIFrame({
            iFrameId: "paymetricIframe",
            targetUrl: paymetricConfig?.message,
            autosizewidth: false,
            autosizeheight: true,
        });
        paymetricIframe.onload();
    };
    useEffect(() => {
        loadCurrentCart({ shouldLoadFullCart: true, replaceCart: true, getCartLines: true });
        if (usePaymetricGateway && paymentMethodDto?.isCreditCard) {
            loadPaymetricConfig();
        }
        getPaymentProfiles(parameter).then(response => {
            const paymentProfileData = response.accountPaymentProfiles?.find(x => x.cardIdentifier === paymentMethodDto?.name);
            setPaymentProfiles(paymentProfileData);
        });
    }, [usePaymetricGateway, paymentMethod]);
    useEffect(() => {
        if (paymetricConfig?.success && paymetricFrameRef.current) {
            const paymetricScript = document.createElement("script");
            paymetricScript.src = paymetricConfig.javaScriptUrl;
            paymetricScript.onload = () => {
                if (paymetricFrameRef.current) {
                    paymetricFrameRef.current.setAttribute("src", paymetricConfig.message);
                    paymetricFrameRef.current.addEventListener("load", setupPaymetricIframe);
                }
            };
            document.body.appendChild(paymetricScript);
        }

        return () => {
            paymetricFrameRef.current?.removeEventListener("load", setupPaymetricIframe);
        };
    }, [paymetricConfig, paymetricFrameRef]);

    const handlePaymentMethodChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setPaymentMethod(event.currentTarget.value);
        validatePaymentMethod(event.currentTarget.value);

        if (event.currentTarget.value === "-1") {
            setIsPayPal(true);
        } else {
            setIsPayPal(false);
        }
    };
    const handlePaymentMethodClick = React.useCallback((event: any) => {
        setIsActive(event.currentTarget.dataset.value);
        setPaymentMethod(event.currentTarget.dataset.value);
        validatePaymentMethod(event.currentTarget.dataset.value);

        if (event.currentTarget.dataset.value === "-1") {
            setIsPayPal(true);
        } else {
            setIsPayPal(false);
        }

        if (event.currentTarget.dataset.value === "94") {
            setIsWirePayment(true);
        }
        else {
            setIsWirePayment(false);
        }

    }, []);

    const handlePONumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPONumber(event.currentTarget.value);
        validatePONumber(event.currentTarget.value);
    };
    const handleTaxCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTaxCodeNumber(event.currentTarget.value);
    };

    const handleVatNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setVatNumber(event.currentTarget.value);
    };
    const handleSaveCardChange = (_: React.SyntheticEvent<Element, Event>, value: boolean) => setSaveCard(value);
    const handleCardHolderNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCardHolderName(event.currentTarget.value);
        validateCardHolderName(event.currentTarget.value);
    };
    const handleCardNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCardNumber(event.currentTarget.value);
        validateCardNumber(event.currentTarget.value);
    };
    const handleCardTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setCardType(event.currentTarget.value);
        validateCardType(event.currentTarget.value);
    };
    const handleExpirationMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const month = Number(event.currentTarget.value);
        if (Number.isNaN(month)) {
            return;
        }
        setExpirationMonth(month);
        validateCardExpiration(month, expirationYear);
    };
    const handleExpirationYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const year = Number(event.currentTarget.value);
        if (Number.isNaN(year)) {
            return;
        }
        setExpirationYear(year);
        validateCardExpiration(expirationMonth, year);
    };
    const handleSecurityCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSecurityCode(event.currentTarget.value);
        validateSecurityCode(event.currentTarget.value);
    };
    const handleUseBillingAddressChange = (_: React.SyntheticEvent<Element, Event>, value: boolean) =>
        setUseBillingAddress(value);
    const handleAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddress1(event.currentTarget.value);
        validateAddress1(event.currentTarget.value);
    };
    const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setCountryId(event.currentTarget.value);
        validateCountry(event.currentTarget.value);
    };
    const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setStateId(event.currentTarget.value);
        validateState(event.currentTarget.value);
    };
    const handleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCity(event.currentTarget.value);
        validateCity(event.currentTarget.value);
    };
    const handlePostalCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPostalCode(event.currentTarget.value);
        validatePostalCode(event.currentTarget.value);
    };

    const handleEditCardClick = () => {
        if (!savedPaymentsPageLink) {
            return;
        }

        history.push(savedPaymentsPageLink.url);
    };

    const validatePaymentMethod = (paymentMethod: string) => {
        const paymentMethodValid =
            isPayPal || !paymentMethods || paymentMethods.length === 0 || isNonEmptyString(paymentMethod);
        setPaymentMethodError(!paymentMethodValid ? translate("Payment Method is required.") : "");
        return paymentMethodValid;
    };

    const validatePONumber = (poNumber: string) => {
        const poNumberValid = !cart || !cart.requiresPoNumber || isNonEmptyString(poNumber);
        setPONumberError(!poNumberValid ? translate("PO Number is required.") : "");
        return poNumberValid;
    };

    const validateCardHolderName = (cardHolderName: string) => {
        const cardHolderNameValid = !paymentMethodDto?.isCreditCard || isNonEmptyString(cardHolderName);
        setCardHolderNameError(!cardHolderNameValid ? translate("Cardholder name is required.") : "");
        return cardHolderNameValid;
    };

    const validateCardNumber = (cardNumber: string) => {
        let cardNumberEmpty = false;
        let cardNumberValid = true;

        if (paymentMethodDto?.isCreditCard && !useTokenExGateway) {
            cardNumberEmpty = !isNonEmptyString(cardNumber);
            cardNumberValid = validateCreditCard(cardNumber);
        }

        if (cardNumberEmpty) {
            setCardNumberError(translate("Credit card number is required."));
        } else if (!cardNumberValid) {
            setCardNumberError(translate("Credit card number is invalid."));
        } else {
            setCardNumberError("");
        }

        return { cardNumberEmpty, cardNumberValid };
    };

    const validateCardType = (cardType: string) => {
        const cardTypeValid =
            !paymentMethodDto?.isCreditCard || useTokenExGateway || (!useTokenExGateway && isNonEmptyString(cardType));
        setCardTypeError(!cardTypeValid ? translate("Credit card type is required.") : "");
        return cardTypeValid;
    };

    const validateCardExpiration = (expirationMonth: number, expirationYear: number) => {
        const cardExpired =
            paymentMethodDto?.isCreditCard && isMonthAndYearBeforeToday(expirationMonth, expirationYear);
        setExpirationError(cardExpired ? translate("Card is expired. Please enter a valid expiration date.") : "");
        return cardExpired;
    };

    const validateSecurityCode = (securityCode: string) => {
        let securityCodeEmpty = false;
        let securityCodeValid = true;

        if (paymentMethodDto?.isCreditCard && !useTokenExGateway) {
            securityCodeEmpty = !isNonEmptyString(securityCode);
            securityCodeValid = /^\d+$/.test(securityCode);
        }

        if (securityCodeEmpty) {
            setSecurityCodeError(!securityCodeValid ? translate("Security code is required.") : "");
        } else if (!securityCodeValid) {
            setSecurityCodeError(translate("Security code is invalid."));
        } else {
            setSecurityCodeError("");
        }

        return { securityCodeEmpty, securityCodeValid };
    };

    const validateAddress1 = (address1: string) => {
        const address1Valid =
            !(paymentMethodDto?.isCreditCard || paymentMethodDto?.isECheck) ||
            useBillingAddress ||
            (!useBillingAddress && isNonEmptyString(address1));
        setAddress1Error(!address1Valid ? translate("Address is required.") : "");
        return address1Valid;
    };

    const validateCountry = (countryId: string) => {
        const countryValid =
            !(paymentMethodDto?.isCreditCard || paymentMethodDto?.isECheck) ||
            useBillingAddress ||
            (!useBillingAddress && isNonEmptyString(countryId));
        setCountryError(!countryValid ? translate("Country is required.") : "");
        return countryValid;
    };

    const validateState = (stateId: string) => {
        const stateValid =
            (!!selectedCountry && !!selectedCountry.states && selectedCountry.states.length <= 0) ||
            !(paymentMethodDto?.isCreditCard || paymentMethodDto?.isECheck) ||
            useBillingAddress ||
            (!useBillingAddress && isNonEmptyString(stateId));
        setStateError(!stateValid ? translate("State is required.") : "");
        return stateValid;
    };

    const validateCity = (city: string) => {
        const cityValid =
            !(paymentMethodDto?.isCreditCard || paymentMethodDto?.isECheck) ||
            useBillingAddress ||
            (!useBillingAddress && isNonEmptyString(city));
        setCityError(!cityValid ? translate("City is required.") : "");
        return cityValid;
    };

    const validatePostalCode = (postalCode: string) => {
        const postalCodeValid =
            !(paymentMethodDto?.isCreditCard || paymentMethodDto?.isECheck) ||
            useBillingAddress ||
            (!useBillingAddress && isNonEmptyString(postalCode));
        setPostalCodeError(!postalCodeValid ? translate("Postal Code is required.") : "");
        return postalCodeValid;
    };

    const validateOrderNotes = (orderNotes: string) => {
        let orderNotesValid = true;
        if (orderNotes?.length) {
            orderNotesValid = validateNonUSKeyBoardCharacters(orderNotes);
            if (!orderNotesValid) {
                setNotesError(orderNotesValidationMessage);
            } else {
                setNotesError('');
            }
        }
        else {
            setNotesError('');
        }
        return orderNotesValid;
    }

    const handleAccountNumberIFrame = (accountNumberIFrame: IFrame) => {
        tokenExAccountNumberIframe = accountNumberIFrame;
    };

    const handlePaymetricValidateSuccess = (success: boolean) => {
        if (success) {
            paymetricIframe.submit({
                onSuccess: (msg: string) => {
                    // The HasPassed is case sensitive, and not standard json.
                    const message: { data: { HasPassed: boolean } } = JSON.parse(msg);
                    if (message.data.HasPassed) {
                        handleSuccessSubmitPaymetricIframe();
                    }
                },
                onError: (msg: string) => {
                    const message: { data: { Code: number } } = JSON.parse(msg);
                    // Code = 150 -> Already submitted
                    if (message.data.Code === 150) {
                        handleSuccessSubmitPaymetricIframe();
                    }
                },
            });
        }
    };

    const handleSuccessSubmitPaymetricIframe = () => {
        if (!paymetricConfig?.accessToken) {
            return;
        }

        getPaymetricResponsePacket({
            accessToken: paymetricConfig.accessToken,
            onComplete: result => {
                if (result.apiResult?.success) {
                    setCardType(convertPaymetricCardType(result.apiResult.creditCard.cardType));
                    setExpirationMonth(result.apiResult.creditCard.expirationMonth!);
                    setExpirationYear(result.apiResult.creditCard.expirationYear!);
                    setCardNumber(result.apiResult.creditCard.cardNumber!);
                    setSecurityCode(result.apiResult.creditCard.securityCode!);
                    setCardHolderName(result.apiResult.creditCard.cardHolderName!);
                    setIsCardNumberTokenized(true);
                }
            },
        });
    };

    const validateForm = () => {
        const paymentMethodValid = validatePaymentMethod(paymentMethod);
        const poNumberValid = validatePONumber(poNumber);

        if (isPayPal) {
            return paymentMethodValid;
        }

        if (useTokenExGateway && (paymentMethodDto?.isPaymentProfile || paymentMethodDto?.isCreditCard)) {
            tokenExIframe?.validate();
        } else if (useECheckTokenExGateway && paymentMethodDto?.isECheck) {
            tokenExAccountNumberIframe?.validate();
        }

        if (usePaymetricGateway && cart && cart.showCreditCard && !cart.requiresApproval) {
            const isFormValidForPaymetricPayment = paymentMethodValid && poNumberValid;
            if (!isFormValidForPaymetricPayment) {
                return false;
            }
            if (paymentMethodDto?.isCreditCard && paymetricIframe) {
                paymetricIframe.validate({
                    onValidate: (success: boolean) => {
                        handlePaymetricValidateSuccess(success);
                    },
                });
            } else if (paymentMethodDto?.isPaymentProfile) {
                return true;
            }
        }

        const cardHolderNameValid = validateCardHolderName(cardHolderName);
        const cardNumberResult = validateCardNumber(cardNumber);
        const cardTypeValid = validateCardType(cardType);
        const cardExpired = validateCardExpiration(expirationMonth, expirationYear);
        const securityCodeResult = validateSecurityCode(securityCode);
        const address1Valid = validateAddress1(address1);
        const countryValid = validateCountry(countryId);
        const stateValid = validateState(stateId);
        const cityValid = validateCity(city);
        const postalCodeValid = validatePostalCode(postalCode);
        const isOrderNotesValid = validateOrderNotes(notes);
        let isValidCollectNumber = true;
        if (cart && cart?.carrier?.description && cart?.carrier?.description?.toLowerCase().endsWith("collect")) {
            const collectNumberValid = validateCollectNumber(collectNumber);
            if (!collectNumberValid) {
                collectNumberRef.current?.focus();
            }
            isValidCollectNumber = collectNumberValid;
        }
        let isTaxCodeNumberValid = true;
        if (taxExempt === "Yes" && !taxExemptDisabled) {
            const taxCodeNumberValid = validateTaxExemptionNumber(taxCodeNumber);
            if (!taxCodeNumberValid) {
                taxExemptCodeNumberRef.current?.focus();
            }
            isTaxCodeNumberValid = taxCodeNumberValid;
        }

        let accountHolderNameValid = true;
        let accountNumberValid = true;
        let routingNumberValid = true;
        if (eCheckDetails?.current) {
            accountHolderNameValid = eCheckDetails.current.validateAccountHolderNameChange(accountHolderName);
            accountNumberValid = eCheckDetails.current.validateAccountNumberChange(accountNumber);
            routingNumberValid = eCheckDetails.current.validateRoutingNumberChange(routingNumber);
        }

        if (!paymentMethodValid) {
            paymentMethodRef.current?.focus();
        } else if (!poNumberValid) {
            poNumberRef.current?.focus();
        } else if (cardNumberResult.cardNumberEmpty || !cardNumberResult.cardNumberValid) {
            cardNumberRef.current?.focus();
        } else if (!cardHolderNameValid) {
            cardHolderNameRef.current?.focus();
        } else if (!cardTypeValid) {
            cardTypeRef.current?.focus();
        } else if (cardExpired) {
            const today = new Date();
            if (expirationYear < today.getFullYear()) {
                expirationYearRef.current?.focus();
            } else {
                expirationMonthRef.current?.focus();
            }
        } else if (securityCodeResult.securityCodeEmpty || !securityCodeResult.securityCodeValid) {
            securityCodeRef.current?.focus();
        } else if (!address1Valid) {
            address1Ref.current?.focus();
        } else if (!countryValid) {
            countryRef.current?.focus();
        } else if (!stateValid) {
            stateRef.current?.focus();
        } else if (!cityValid) {
            cityRef.current?.focus();
        } else if (!postalCodeValid) {
            postalCodeRef.current?.focus();
        }

        return (
            paymentMethodValid &&
            poNumberValid &&
            cardHolderNameValid &&
            !cardNumberResult.cardNumberEmpty &&
            cardNumberResult.cardNumberValid &&
            cardTypeValid &&
            !cardExpired &&
            !securityCodeResult.securityCodeEmpty &&
            securityCodeResult.securityCodeValid &&
            address1Valid &&
            countryValid &&
            stateValid &&
            cityValid &&
            postalCodeValid &&
            accountHolderNameValid &&
            accountNumberValid &&
            routingNumberValid &&
            isValidCollectNumber &&
            isTaxCodeNumberValid &&
            isOrderNotesValid
        );


    };

    const prependPromotionCodeToNotes = () => {
        const promotionCodeMessageToPrepend = `${cart?.properties?.promoCodeMessage} ${cart?.promotionCode}`;
        const tempNotes = `${promotionCodeMessageToPrepend} ${notes}`;
        setOrderNote(tempNotes);
    };

    const validateForShippingTermsForClassifiedProducts = () => {
        if(isShippingTermsEnabled) {
            const shippingConsented = getCookie(COOKIE_KEYS.COOKIE_SHIPPING_TERMS_ACCEPTED);
            if(shippingConsented === 'false') {
                setModalOpen(true);
                return false;
            }
        }
        return true;
    }

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const isShippingTermsAccepted = validateForShippingTermsForClassifiedProducts();
        if (!validateForm() || !isShippingTermsAccepted) {
            setShowFormErrors(true);
            return false;
        }
        if (useTokenExGateway && (paymentMethodDto?.isPaymentProfile || paymentMethodDto?.isCreditCard) && !isPayPal) {
            tokenExIframe?.tokenize();            
        } else if (useECheckTokenExGateway && !isPayPal && paymentMethodDto?.isECheck) {
            tokenExAccountNumberIframe?.tokenize();
        } else {
            if (cart?.promotionCode !== "" && cart?.promotionCode !== null) {
                prependPromotionCodeToNotes();
            }
            const props = {
                ...cart?.properties,
                customerFreightBillingAcctNumber: collectNumber,
                taxExemptionNumber: taxExempt === "Yes" ? taxCodeNumber : "",
            };
            placeOrder({
                paymentMethod,
                poNumber,
                vatNumber,
                saveCard,
                cardHolderName,
                cardNumber,
                cardType,
                expirationMonth,
                expirationYear,
                securityCode,
                useBillingAddress,
                address1,
                countryId,
                stateId,
                city,
                postalCode,
                payPalToken,
                payPalPayerId,
                accountHolderName,
                accountNumber,
                routingNumber,
                properties: props || {},
                notes,
                taxExemptionMessage,
                attentionMessage,
                payerId: "",
                maskedCardNumber,
                onSuccess: (cartId: string) => {
                    preloadOrderConfirmationData({
                        cartId,
                        onSuccess: () => {
                            if (cart?.isAwaitingApproval) {
                                toaster.addToast({
                                    body: siteMessage("OrderApproval_OrderPlaced"),
                                    messageType: "success",
                                });
                            }
                            if(cart != null){
                                checkoutReviewAndPayTracking(cart)
                            }
                            history.push(`${orderConfirmationPageLink!.url}?cartId=${cartId}`);
                        },
                    });
                },
                onComplete(resultProps: any) {
                    if (!resultProps.apiResult?.cart) {
                        return;
                    }
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult.cart.id);
                },
            } as PlaceOrderParameter);
        }
        return false;
    };

    const submitPayPalRequest = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        if (!checkoutReviewAndSubmitPageLink) {
            return;
        }
        if (!session?.isAuthenticated) {
            return;
        }
        setPaymentMethod("");
        setRunSubmitPayPal(true);
        setIsPayPal(true);
    };

    if (!tokenExFrameStyleConfig) {
        tokenExFrameStyleConfig = generateTokenExFrameStyleConfig({ theme });
    }

    if (!cart || cart.requiresApproval || !paymentOptions || !orderConfirmationPageLink) {
        return null;
    }

    const validateCollectNumber = (collectNumber: string) => {
        const collectNumberValidNumberValid = /^([a-zA-Z0-9]+)$/.test(collectNumber);
        const collectNumberValid = !!(collectNumber && isNonEmptyString(collectNumber));
        if (!collectNumberValid) {
            setCollectNumberError(translate("Collect number is required."));
            return false;
        }
        if (!collectNumberValidNumberValid) {
            setCollectNumberError(translate("Invalid format."));
            return false;
        }
        if (collectNumber.length < 6) {
            setCollectNumberError(translate("Please enter at least 6 characters."));
            return false;
        }
        if (collectNumber.length > 9) {
            setCollectNumberError(translate("Collect Number field exceeds maximum length of 9."));
            return false;
        }
        setCollectNumberError("");
        return true;
    };
    const validateTaxExemptionNumber = (texempionNumber: string) => {
        const texempionNumberValid = !!(texempionNumber && isNonEmptyString(texempionNumber));
        if (!texempionNumberValid) {
            setTaxExemptionNumberError(translate("Tax exemption number is required."));
            return false;
        }

        setTaxExemptionNumberError("");
        const taxCartMessage = cart?.properties?.taxCertMessage || "undefined";
        if (
            isTaxCertificateAvailableOnCustomer === false &&
            taxExempt === "Yes" &&
            notes?.includes(taxCartMessage) === false
        ) {
            setTaxExemptionMessage(`${cart?.properties?.taxCertMessage?.trim()} ${taxCodeNumber}\n`);
        }
        return true;
    };

    const handleTaxEmemptFlagChanged = (_: React.SyntheticEvent, value: boolean) => {
        setTaxExempt(value ? "Yes" : "No");
        setIsTaxExempionNumber(true);
    };

    const applyPaymentProfile = () => {
        if (selectPaymentProfile) {
            useAsDefaultClickHandler(selectPaymentProfile);
        }
    }

    const handleTooltipKeyDown = (e: React.KeyboardEvent) => {
        if (e.keyCode === 27) {
            e.stopPropagation();
            setShowText(false);
        }
        if (e.keyCode === 13) {
            e.stopPropagation();
            setShowText(!showText);
        }
    };

    const handleClose = () => {
        setModalOpen(false);
    }

    return (
        <>
        <StyledForm
            {...styles.form}
            id="reviewAndSubmitPaymentForm"
            onSubmit={handleFormSubmit}
            noValidate={true}
            data-test-selector="reviewAndSubmitPaymentForm"
        >
            <CheckoutReviewAndSubmitCarrierService
                collectNumberData={selectCollectNumberDataHandler}
                shipToAddressFieldsData={shipToAddressFields}
                collectNumberErrorData={collectNumberError}
                updateShippingComponentState={updateShippingComponentState}
                isShippingTermsEnabled={isShippingTermsEnabled}
            ></CheckoutReviewAndSubmitCarrierService>
            {shippingState && (<StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>)}

            {cart.showTaxAndShipping && currencyCode === "USD" && (
                <>
                    {!session.isGuest && (
                        <>
                            <GridContainer {...styles.spacingAdjust}>
                                <GridItem {...styles.taxExemptGridItem}>
                                    <>
                                        <h2 className="section-heading">{translate("Tax Information")}</h2>
                                        <CheckboxGroup>
                                            <Checkbox
                                                uid="taxExemptCheckbox"
                                                labelPosition="right"
                                                checked={taxExempt === "Yes"}
                                                variant="toggle"
                                                onChange={handleTaxEmemptFlagChanged}
                                                iconProps={{
                                                    ...styles.checkBoxProps,
                                                }}
                                                disabled={taxExemptDisabled}
                                            >
                                                {fields.taxExemptHeaderText}
                                            </Checkbox>
                                        </CheckboxGroup>
                                    </>
                                </GridItem>
                                <GridItem {...styles.taxExemptmsgContainer} className="tax-msg-container">
                                    {cart?.totalTax === 0 && (
                                        <>
                                            <Typography {...styles.taxExemptText}>{fields.alreadyTaxExempt}</Typography>
                                        </>
                                    )}
                                    {cart?.totalTax > 0 && taxExempt === "No" && (
                                        <>
                                            <Typography {...styles.taxExemptText}>{fields.taxNotExempt}</Typography>
                                        </>
                                    )}
                                    {cart?.totalTax > 0 && taxExempt === "Yes" && (
                                        <>
                                            <Typography {...styles.taxExemptText}>
                                                {fields.taxExemptFooterText}
                                            </Typography>
                                            <TextField
                                                {...styles.taxCodeNumberText}
                                                label={
                                                    <>
                                                        <span aria-hidden> {siteMessage("TaxExemptHeaderValue")}</span>
                                                        <VisuallyHidden>
                                                            {siteMessage("TaxExemptHeaderValue")}
                                                        </VisuallyHidden>
                                                    </>
                                                }
                                                value={taxCodeNumber}
                                                onChange={handleTaxCodeChange}
                                                data-test-selector="checkoutReviewAndSubmit_taxCodeNumber"
                                                onBlur={e => validateTaxExemptionNumber(e.currentTarget.value)}
                                                onKeyUp={e => validateTaxExemptionNumber(e.currentTarget.value)}
                                                required
                                                error={taxExemptionNumberError}
                                                ref={taxExemptCodeNumberRef}
                                            />
                                        </>
                                    )}
                                </GridItem>
                            </GridContainer>
                        </>
                    )}
                </>
            )}

            {cart.showTaxAndShipping && currencyCode === "GBP" && (
                <>
                    {!session.isGuest && (
                        <>
                            <GridContainer {...styles.spacingAdjust}>
                                <GridItem {...styles.taxExemptGridItem}>
                                    <>
                                        <h2 className="section-heading">{translate("VAT Information")}</h2>
                                        <CheckboxGroup>
                                            <Checkbox
                                                uid="taxExemptCheckbox"
                                                labelPosition="right"
                                                checked={taxExempt === "Yes"}
                                                variant="toggle"
                                                onChange={handleTaxEmemptFlagChanged}
                                                iconProps={{
                                                    ...styles.checkBoxProps,
                                                }}
                                                disabled={taxExemptDisabled}
                                            >
                                                {fields.taxExemptHeaderText}
                                            </Checkbox>
                                        </CheckboxGroup>
                                        {taxExemptDisabled}
                                    </>
                                </GridItem>
                                <GridItem {...styles.taxExemptmsgContainer} className="tax-input-container">
                                    {cart?.totalTax === 0 && (
                                        <>
                                            <Typography {...styles.taxExemptText}>{fields.alreadyTaxExempt}</Typography>
                                        </>
                                    )}
                                    {cart?.totalTax > 0 && (
                                        <>
                                            <Typography>
                                                <Typography {...styles.taxExemptText}>{fields.taxNotExempt}</Typography>
                                            </Typography>
                                            <TextField
                                                {...styles.vatNumberText}
                                                label={translate("VAT #")}
                                                value={vatNumber}
                                                onChange={handleVatNumberChange}
                                                maxLength={50}
                                                data-test-selector="checkoutReviewAndSubmit_vatNumber"
                                            />
                                        </>
                                    )}
                                </GridItem>
                            </GridContainer>
                        </>
                    )}
                </>
            )}
            <StyledFieldSet {...styles.fieldset}>
                <Typography {...styles.paymentDetailsHeading} as="h2" className="section-heading">
                    {translate("Payment Method & Billing")}
                </Typography>

                <Typography as="div" {...styles.paymentContainer}>
                    {isPayPal && (
                        <>
                            <GridContainer {...styles.paymentMethodAndPONumberContainer}>
                                <GridItem {...styles.paymentMethodGridItem}>
                                    {paymentMethods && paymentMethods.length > 0 && (
                                        <>
                                            <Hidden above="md" className="payment-method-mobile">
                                                <Select
                                                    {...styles.paymentMethodSelect}
                                                    label={translate("Select Your Prefered Payment Method")}
                                                    value={paymentMethod ?? paymentMethodDto?.name}
                                                    onChange={handlePaymentMethodChange}
                                                    required
                                                    error={showFormErrors && paymentMethodError}
                                                    data-test-selector="checkoutReviewAndSubmit_paymentMethod"
                                                    ref={paymentMethodRef}
                                                >
                                                    <option value="">{translate("Select Payment Method")}</option>
                                                    {paymentMethods.map(method => (
                                                        <>
                                                            {method.isPaymentProfile === false &&
                                                                <option key={method.name} value={method.name}>
                                                                    {method.description}
                                                                </option>
                                                            }
                                                        </>
                                                    ))}
                                                    {isPayPal &&
                                                        <option value="-1">{translate("PayPal")}</option>
                                                    }

                                                </Select>
                                            </Hidden>
                                            <Hidden below="lg" className="payment-method-desktop">
                                                <Typography as="div" className={`button-container ${showFormErrors && paymentMethodError ? "payment-error" : ""}`}>
                                                    {paymentMethods.map(method => (
                                                        <>
                                                            {method.cardType === null &&
                                                                (method.description !== "Net 30" ? (
                                                                    <span
                                                                        className={`${isActive === method.name ? "current" : ""
                                                                            } select-pay-button`}
                                                                        key={method.name}
                                                                        data-value={method.name}
                                                                        onClick={handlePaymentMethodClick}
                                                                        onKeyDown={(e) => e.keyCode === 13 ? e.currentTarget.click() : ''}
                                                                    >
                                                                        {method.description}
                                                                    </span>
                                                                ) : (
                                                                    <>
                                                                        <span
                                                                            className={`${isActive === method.name
                                                                                ? "current"
                                                                                : ""
                                                                                } select-pay-button`}
                                                                            key={method.name}
                                                                            data-value={method.name}
                                                                            onClick={handlePaymentMethodClick}
                                                                            onKeyDown={(e) => e.keyCode === 13 ? e.currentTarget.click() : ''}                                                                            >
                                                                            {method.description}
                                                                        </span>
                                                                        <Typography
                                                                            as="span"
                                                                            {...styles.tooltipIcon}
                                                                            onClick={() => setShowText(!showText)}
                                                                            onKeyDown={(e: any) =>
                                                                                e.keyCode === 27
                                                                                    ? setShowText(false)
                                                                                    : ""
                                                                            }
                                                                            onBlur={() => setShowText(false)}
                                                                        >
                                                                            <Icon src={InfoNewIcon} size={20} />
                                                                        </Typography>
                                                                        <Typography
                                                                            as="div"
                                                                            {...styles.tooltip}
                                                                            className={`${showText ? "active" : ""}`}
                                                                        >
                                                                            <Typography
                                                                                as="div"
                                                                                {...styles.tooltipContent}
                                                                            >
                                                                                {Net30PaymentText}{" "}
                                                                            </Typography>
                                                                        </Typography>
                                                                    </>
                                                                )

                                                                )}
                                                        </>
                                                    ))}
                                                    {isPayPal && (
                                                        <span
                                                            className={`${isActive === "-1" ? "current" : ""
                                                                } select-pay-button`}
                                                            data-value="-1"
                                                            onClick={handlePaymentMethodClick}
                                                            onKeyDown={(e) => e.keyCode === 13 ? e.currentTarget.click() : ''}
                                                        >
                                                            {translate("PayPal")}
                                                        </span>
                                                    )}
                                                </Typography>
                                                <Typography as="div" {...styles.paymentMethodsErrorDesktop}>
                                                    {showFormErrors && paymentMethodError && (
                                                        <Typography data-test-selector="checkoutReviewAndSubmit_paymentMethod_error_desktop">
                                                            <Icon
                                                                src={WarningNotification}
                                                                style={{ color: "#c63527", fill: "#c63527", height: "22px", width: "25px", display: "inline-block", verticalAlign: "bottom" }}
                                                            />
                                                            {paymentMethodError}
                                                        </Typography>
                                                    )}
                                                </Typography>
                                            </Hidden>
                                            {paymentMethodDto?.isPaymentProfile &&
                                                !paymentMethodDto.isPaymentProfileExpired && (
                                                    <PaymentProfileBillingAddress
                                                        address={paymentMethodDto.billingAddress}
                                                        extendedStyles={styles.paymentProfileBillingAddress}
                                                        nameOnCard={paymentProfiles?.cardHolderName}
                                                        cardNumber={paymentProfiles?.maskedCardNumber}
                                                        expiryDate={paymentProfiles?.expirationDate}
                                                    />
                                                )}
                                            {paymentMethodDto?.isPaymentProfile &&
                                                paymentMethodDto.isPaymentProfileExpired && (
                                                    <StyledWrapper {...styles.paymentProfileExpiredErrorWrapper}>
                                                        <Typography {...styles.paymentProfileExpiredErrorText}>
                                                            {siteMessage("Checkout_PaymentProfileExpired")}
                                                        </Typography>
                                                        {savedPaymentsPageLink && (
                                                            <Link
                                                                {...styles.paymentProfileEditCardLink}
                                                                onClick={handleEditCardClick}
                                                            >
                                                                {translate("Edit Card")}
                                                            </Link>
                                                        )}
                                                    </StyledWrapper>
                                                )}
                                        </>
                                    )}

                                </GridItem>
                            </GridContainer>

                            <Typography {...styles.paymentMethodPayPalText} as="span">
                                <PayPalButton
                                    {...styles.payPalButton}
                                    submitPayPalRequest={submitPayPalRequest}
                                    error={showFormErrors ? payPalError : undefined}
                                ></PayPalButton>
                            </Typography>
                        </>
                    )}
                    {!isPayPal && (
                        <GridContainer {...styles.paymentMethodAndPONumberContainer} data-test-selector="payment-ponumbercontainer">
                            <GridItem {...styles.paymentMethodGridItem}>
                                {paymentMethods && paymentMethods.length > 0 && (
                                    <>
                                        <Hidden above="md" className="payment-method-mobile">
                                            <Select
                                                {...styles.paymentMethodSelect}
                                                label={translate("Payment Method")}
                                                value={paymentMethod ?? paymentMethodDto?.name}
                                                onChange={handlePaymentMethodChange}
                                                required
                                                error={showFormErrors && paymentMethodError}
                                                data-test-selector="checkoutReviewAndSubmit_paymentMethod"
                                                ref={paymentMethodRef}
                                                key="paymentMethodSelectMobile"
                                            >
                                                <option value="" key="none">{translate("Select Payment Method")}</option>
                                                {paymentMethods.map(method => (
                                                    <>
                                                        {method.isPaymentProfile === false &&
                                                            <option key={method.name} value={method.name}>
                                                                {method.description}
                                                            </option>
                                                        }
                                                    </>
                                                ))}
                                                {isPayPal && (
                                                    <option value="-1" key="paypal">
                                                        {translate("PayPal")}
                                                    </option>
                                                )}
                                            </Select>
                                        </Hidden>
                                        <Hidden below="lg" className="payment-method-desktop">
                                            <Typography as="div" className={`button-container ${showFormErrors && paymentMethodError ? "payment-error" : ""}`}>
                                                {paymentMethods.map(method => (
                                                    <>
                                                        {method.cardType === null &&
                                                            (method.description !== "Net 30" ? (
                                                                <span
                                                                    className={`${isActive === method.name ? "current" : ""
                                                                        } select-pay-button`}
                                                                    key={method.name}
                                                                    data-value={method.name}
                                                                    onClick={handlePaymentMethodClick}
                                                                    onKeyDown={(e) => e.keyCode === 13 ? e.currentTarget.click() : ''}
                                                                >
                                                                    {method.description}
                                                                </span>
                                                            ) : (
                                                                <>
                                                                    <span
                                                                        className={`${isActive === method.name ? "current" : ""
                                                                            } select-pay-button`}
                                                                        key={method.name}
                                                                        data-value={method.name}
                                                                        onClick={handlePaymentMethodClick}
                                                                        onKeyDown={(e) => e.keyCode === 13 ? e.currentTarget.click() : ''}
                                                                    >
                                                                        {method.description}

                                                                        <Typography
                                                                            as="span"
                                                                            tabIndex={0}
                                                                            {...styles.tooltipIcon}
                                                                            onClick={() => setShowText(!showText)}
                                                                            onKeyDown={(e: any) => handleTooltipKeyDown(e)}
                                                                            onBlur={() => setShowText(false)}
                                                                        >
                                                                            <Icon src={InfoNewIcon} size={20} />
                                                                        </Typography>
                                                                        <Typography
                                                                            as="div"
                                                                            {...styles.tooltip}
                                                                            className={`${showText ? "active" : ""}`}
                                                                        >
                                                                            <Typography as="div" {...styles.tooltipContent}>
                                                                                {Net30PaymentText}{" "}
                                                                            </Typography>
                                                                        </Typography>
                                                                    </span>
                                                                </>
                                                            ))}
                                                    </>
                                                ))}
                                                {isPayPal && (
                                                    <span
                                                        className={`${isActive === "-1" ? "current" : ""
                                                            } select-pay-button`}
                                                        data-value="-1"
                                                        onClick={handlePaymentMethodClick}
                                                        onKeyDown={(e) => e.keyCode === 13 ? e.currentTarget.click() : ''}
                                                    >
                                                        {translate("PayPal")}
                                                    </span>
                                                )}
                                            </Typography>
                                            <Typography as="div" {...styles.paymentMethodsErrorDesktop}>
                                                {showFormErrors && paymentMethodError && (
                                                    <Typography data-test-selector="checkoutReviewAndSubmit_paymentMethod_error_desktop">
                                                        <Icon
                                                            src={WarningNotification}
                                                            style={{ color: "#c63527", fill: "#c63527", height: "22px", width: "25px", display: "inline-block", verticalAlign: "bottom" }}
                                                        />
                                                        {paymentMethodError}
                                                    </Typography>
                                                )}
                                            </Typography>
                                        </Hidden>

                                        {paymentMethodDto?.isPaymentProfile &&
                                            paymentMethodDto.isPaymentProfileExpired && (
                                                <StyledWrapper {...styles.paymentProfileExpiredErrorWrapper}>
                                                    <Typography {...styles.paymentProfileExpiredErrorText}>
                                                        {siteMessage("Checkout_PaymentProfileExpired")}
                                                    </Typography>
                                                    {savedPaymentsPageLink && (
                                                        <Link
                                                            {...styles.paymentProfileEditCardLink}
                                                            onClick={handleEditCardClick}
                                                        >
                                                            {translate("Edit Card")}
                                                        </Link>
                                                    )}
                                                </StyledWrapper>
                                            )}
                                    </>
                                )}
                            </GridItem>

                            {paymentMethods && paymentMethods.length > 0 && paymentMethodDto?.isPaymentProfile &&
                                !paymentMethodDto.isPaymentProfileExpired && (
                                    <GridItem {...styles.creditCardSelectedDetailsGridItem}>
                                        <Typography {...styles.selectCard} as="div">
                                            <Typography {...styles.titleContainer} as="div">
                                                <h3 className="card-heading">{translate("Card Information")}</h3>
                                                <Link
                                                    type="button"
                                                    data-test-selector="checkoutBilling_selectCard"
                                                    onClick={cardEditSelectorModalCloseHandler}
                                                >
                                                    <Typography className="select-card">{translate("Select saved credit card")}</Typography>
                                                    <Icon src={EditIcon} />
                                                </Link>
                                            </Typography>
                                            <PaymentProfileBillingAddress
                                                address={paymentMethodDto.billingAddress}
                                                extendedStyles={styles.paymentProfileBillingAddress}
                                                nameOnCard={paymentProfiles?.cardHolderName}
                                                cardNumber={paymentProfiles?.maskedCardNumber}
                                                expiryDate={paymentProfiles?.expirationDate}
                                            />
                                        </Typography>


                                        {paymentMethodDto?.isPaymentProfile && !paymentMethodDto.isPaymentProfileExpired && (
                                            <SavedPaymentProfileEntry
                                                iframe={
                                                    useTokenExGateway
                                                        ? "TokenEx"
                                                        : usePaymetricGateway
                                                            ? "Paymetric"
                                                            : undefined
                                                }
                                                isTokenExIframeLoaded={isTokenExIframeLoaded}
                                                securityCode={securityCode}
                                                onSecurityCodeChange={handleSecurityCodeChange}
                                                securityCodeError={showFormErrors ? securityCodeError : undefined}
                                                extendedStyles={styles.savedPaymentProfile}
                                            />
                                        )}
                                    </GridItem>
                                )}

                            {cart.showPoNumber && enableVat && <GridItem {...styles.emptyGridItem}></GridItem>}
                            {isWirePayment && (
                                <GridItem {...styles.wirePaymentGridItem}>
                                    <WirePaymentEntry
                                        paymentMethod={paymentMethodDto?.name}
                                        BankName={fields.txtBankName}
                                        BankAddress={fields.txtBankAddress}
                                        BankPhone={fields.txtBankPhone}
                                        BankContactEmail={fields.txtBankContactEmail}
                                        BankContactName={fields.txtBankContactName}
                                        BankAccountName={fields.txtBankAccountName}
                                        BankAccountNumber={fields.txtBankAccountNumber}
                                        BankSwift={fields.txtBankSwift}
                                        BankARBRounting={fields.txtBankARBRounting}
                                        BankCurrency={fields.txtBankCurrency}
                                        TaxIDNumber={fields.txtTaxIDNumber}
                                        AccountReceivableContactName={fields.txtAccountReceivableContactName}
                                        AccountReceivableContactPhone={fields.txtAccountReceivableContactPhone}
                                        AccountReceivableContactEmail={fields.txtAccountReceivableContactEmail}
                                        AccountReceivableContactACHEmailRemittance={fields.txtAccountReceivableContactACHEmailRemittance}></WirePaymentEntry>
                                </GridItem>
                            )}
                            {cart.showCreditCard && paymentMethodDto?.isCreditCard && (
                                <GridItem {...styles.creditCardDetailsGridItem}>
                                    <CreditCardDetailsEntry
                                        canSaveCard={paymentOptions.canStorePaymentProfile}
                                        iframe={
                                            useTokenExGateway
                                                ? "TokenEx"
                                                : usePaymetricGateway
                                                    ? "Paymetric"
                                                    : undefined
                                        }
                                        paymetricFrameRef={paymetricFrameRef}
                                        isTokenExIframeLoaded={isTokenExIframeLoaded}
                                        saveCard={saveCard}
                                        onSaveCardChange={handleSaveCardChange}
                                        cardHolderName={cardHolderName}
                                        cardHolderNameRef={cardHolderNameRef}
                                        onCardHolderNameChange={handleCardHolderNameChange}
                                        cardHolderNameError={showFormErrors ? cardHolderNameError : undefined}
                                        cardNumber={cardNumber}
                                        cardNumberRef={cardNumberRef}
                                        onCardNumberChange={handleCardNumberChange}
                                        cardNumberError={showFormErrors ? cardNumberError : undefined}
                                        cardType={cardType}
                                        cardTypeRef={cardTypeRef}
                                        possibleCardType={possibleCardType}
                                        onCardTypeChange={handleCardTypeChange}
                                        cardTypeError={showFormErrors ? cardTypeError : undefined}
                                        expirationMonth={expirationMonth}
                                        expirationMonthRef={expirationMonthRef}
                                        onExpirationMonthChange={handleExpirationMonthChange}
                                        expirationYear={expirationYear}
                                        expirationYearRef={expirationYearRef}
                                        onExpirationYearChange={handleExpirationYearChange}
                                        expirationError={showFormErrors ? expirationError : undefined}
                                        securityCode={securityCode}
                                        securityCodeRef={securityCodeRef}
                                        onSecurityCodeChange={handleSecurityCodeChange}
                                        securityCodeError={showFormErrors ? securityCodeError : undefined}
                                        availableCardTypes={paymentOptions.cardTypes ?? []}
                                        availableMonths={paymentOptions.expirationMonths ?? []}
                                        availableYears={paymentOptions.expirationYears ?? []}
                                        extendedStyles={styles.creditCardDetails}
                                        cardModalOpen={setCardModalOpen}
                                        currentUserIsGuest={currentUserIsGuest}
                                    />
                                </GridItem>
                            )}

                            {cart.showECheck && paymentMethodDto?.isECheck && (
                                <GridItem {...styles.eCheckDetailsGridItem}>
                                    <ECheckDetailsEntry
                                        iframe={useECheckTokenExGateway ? "TokenEx" : undefined}
                                        paymentMethod={paymentMethod}
                                        onAccountHolderNameChange={setAccountHolderName}
                                        onAccountNumberChange={setAccountNumber}
                                        onRoutingNumberChange={setRoutingNumber}
                                        tokenExConfig={tokenExConfig}
                                        tokenExFrameStyleConfig={tokenExFrameStyleConfig}
                                        extendedStyles={styles.eCheckDetailsEntryStyles}
                                        showFormErrors={showFormErrors}
                                        updateIsECheckTokenized={setIsECheckTokenized}
                                        updateShowFormErrors={setShowFormErrors}
                                        setAccountNumberIFrame={handleAccountNumberIFrame}
                                        ref={eCheckDetails}
                                    />
                                </GridItem>
                            )}
                            {cart.showPoNumber && paymentMethod && (
                                <GridItem {...styles.poNumberGridItem}>
                                    <Typography as="div" className="po-container">
                                        <TextField
                                            {...styles.poNumberText}
                                            className="po-text-field"
                                            label={
                                                <>
                                                    <span aria-hidden>
                                                        {translate("PO #")}{" "}
                                                        {!cart.requiresPoNumber ? (
                                                            <span className="optional">{translate("(Optional)")}</span>
                                                        ) : ''}
                                                    </span>
                                                    <VisuallyHidden>
                                                        {translate("Purchase Order Number")}
                                                    </VisuallyHidden>
                                                </>
                                            }
                                            value={poNumber}
                                            onChange={handlePONumberChange}
                                            required={cart.requiresPoNumber}
                                            maxLength={50}
                                            error={showFormErrors && poNumberError}
                                            data-test-selector="checkoutReviewAndSubmit_poNumber"
                                            ref={poNumberRef}
                                        />
                                    </Typography>
                                </GridItem>
                            )}

                            {!isWirePayment && (
                                <GridItem {...styles.creditCardAddressGridItem}>
                                    <CreditCardBillingAddressEntry
                                        useBillTo={useBillingAddress}
                                        onUseBillToChange={handleUseBillingAddressChange}
                                        billTo={billToState.value}
                                        address1={address1}
                                        address1Ref={address1Ref}
                                        onAddress1Change={handleAddressChange}
                                        address1Error={showFormErrors ? address1Error : undefined}
                                        country={countryId}
                                        countryRef={countryRef}
                                        onCountryChange={handleCountryChange}
                                        countryError={showFormErrors ? countryError : undefined}
                                        state={stateId}
                                        stateRef={stateRef}
                                        onStateChange={handleStateChange}
                                        stateError={showFormErrors ? stateError : undefined}
                                        city={city}
                                        cityRef={cityRef}
                                        onCityChange={handleCityChange}
                                        cityError={showFormErrors ? cityError : undefined}
                                        postalCode={postalCode}
                                        postalCodeRef={postalCodeRef}
                                        onPostalCodeChange={handlePostalCodeChange}
                                        postalCodeError={showFormErrors ? postalCodeError : undefined}
                                        availableCountries={countries ?? []}
                                        availableStates={selectedCountry?.states}
                                        extendedStyles={styles.creditCardAddress}
                                    />
                                </GridItem>
                            )}
                        </GridContainer>
                    )}
                </Typography>
            </StyledFieldSet>
            {/* This button should only be used to trigger the submit of the form, it is required for IE11 to function. */}
            <button id="reviewAndSubmitPaymentForm-submit" type="submit" style={{ display: "none" }}>
                {translate("Place Order")}
            </button>

            <Modal
                {...styles.customBillingBookModal}
                headline={translate("Select a saved credit card")}
                isOpen={openCartModel}
                handleClose={cardSelectorModalCloseHandler}
                data-test-selector="checkoutSelect_addressModal"
                className="cc-modal"
            >
                <Typography as="div" onClick={cardSelectorModalCloseHandler} {...styles.closeContainer}>
                    <span className="close-label">Close</span>
                    <Icon className="icon-close" src="XCircle" />
                </Typography>

                <Typography as="div" className="modal-title">
                    <Typography as="h2" className={`${selectSavedCard ? "current" : ""}`}>
                        {translate("Select a saved credit card")}
                    </Typography>

                    <Typography as="h2" className={`${addNewCard && !editCard ? "current" : ""}`}>
                        {translate("Add a new credit card")}
                    </Typography>
                    <Typography as="h2" className={`${editCard ? "current" : ""}`}>
                        {translate("Edit a saved credit card information")}
                    </Typography>
                </Typography>

                {!editCard &&
                    <StyledWrapper {...styles.buttonWrapper}>
                        <Button
                            {...styles.selectSavedCardButton}
                            data-test-selector="selectSavedCard"
                            className={`${selectSavedCard ? "current" : ""}`}
                            onClick={showCardList}
                        >
                            <StyledWrapper as="span" className="text">
                                {translate("Select a saved credit card")}
                            </StyledWrapper>
                            <Hidden above="sm">
                                <StyledWrapper as="span" className="arrows">
                                    <Icon className="up-arrow" src="ChevronUp" size={16} />
                                    <Icon className="down-arrow" src="ChevronDown" size={16} />
                                </StyledWrapper>
                            </Hidden>
                        </Button>
                        <Button
                            {...styles.wideCreateNewAddressButton}
                            data-test-selector="addNewCard"
                            className={`${addNewCard ? "current" : ""}`}
                            onClick={showNewCardForm}
                        >
                            <StyledWrapper as="span" className="text">
                                {translate("Add a new credit card")}
                            </StyledWrapper>
                            <Hidden above="sm">
                                <StyledWrapper as="span" className="arrows">
                                    <Icon className="up-arrow" src="ChevronUp" size={16} />
                                    <Icon className="down-arrow" src="ChevronDown" size={16} />
                                </StyledWrapper>
                            </Hidden>
                        </Button>
                    </StyledWrapper>
                }
                {!editCard &&
                    <StyledWrapper as="span" className="border-seperator"></StyledWrapper>
                }


                <StyledWrapper className={`toggle-content select-card ${selectSavedCard ? "active" : ""}`}>
                    <SavedPaymentsCardListReviewAndPay
                        editPaymentProfile={setSavedPaymentProfile}
                        showEditForm={showNewOrEditCardForm}
                        updateList={selectSavedCard}
                        selectCreditCard={selectCreditCardHandler}
                        cardModalOpen={cardSelectorModalCloseHandler}
                    />
                    <StyledWrapper {...styles.cardBookModalButtonsWrapper} className="select-card-btn">
                        <StyledWrapper className="btn-wrapper">
                            <StyledWrapper>
                                <Button
                                    {...styles.cardBookModalCancelButton}
                                    onClick={cardSelectorModalCloseHandler}
                                    data-test-selector="cardModal_cancel"
                                    className="cancel-btn"
                                >
                                    {translate("Cancel")}
                                </Button>
                                <Button
                                    data-test-selector="addressModal_continue"
                                    {...styles.addressBookModalContinueButton}
                                    onClick={() => applyPaymentProfile()}
                                >
                                    {translate("Continue")}
                                </Button>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>

                <StyledWrapper className={`toggle-content ${addNewCard ? "active" : ""}`}>
                    <StyledForm id="editPaymentDetailsCardForm" data-test-selector="editCardModal">
                        <SavedPaymentsReviewAndPay
                            editingPaymentProfile={editCard ? savedPaymentProfile : undefined}
                            addNew={addNewCard}
                            editCard={editCard}
                            cardModalOpen={cardSelectorModalCloseHandler}
                            billTo={billToState.value}
                        />
                    </StyledForm>
                    <StyledWrapper {...styles.cardBookModalButtonsWrapper}>
                        <Button
                            {...styles.cardBookModalCancelButton}
                            onClick={cardSelectorModalCloseHandler}
                            data-test-selector="cardModal_cancel"
                            className="cancel-btn"
                        >
                            {translate("Cancel")}
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>


            </Modal>

            <CheckoutReviewAndSubmitProductList
                orderNotesData={collectOrderNotesDataHandler}
                notesErrorData={notesError}></CheckoutReviewAndSubmitProductList>
        </StyledForm>
        <ShippingTermsConsentModal isModalOpen={modalOpen} onClose={handleClose}/>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withToaster(withHistory(withTheme(CheckoutReviewAndSubmitPaymentDetails)))),
    definition: {
        group: "Checkout - Review & Submit",
        displayName: "Payment Details",
        allowedContexts: [CheckoutReviewAndSubmitPageContext],
        fieldDefinitions: [
            {
                name: fields.taxExemptHeaderText,
                displayName: "Tax Exempt Header Text",
                editorTemplate: "TextField",
                defaultValue: "Is this Order tax exempt?",
                fieldType: "General",
            },
            {
                name: fields.taxExemptFooterText,
                displayName: "Tax Exempt Footer Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.alreadyTaxExempt,
                displayName: "Already Tax Exmept",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.taxNotExempt,
                displayName: "Tax Not Exmept",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.checkboxFieldValue,
                displayName: "Display Wire Payment Field",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                dependentFields: [fields.txtBankName, fields.txtBankAddress, fields.txtBankPhone, fields.txtBankContactName, fields.txtBankContactEmail, fields.txtBankAccountName, fields.txtBankAccountNumber,
                fields.txtBankSwift, fields.txtBankARBRounting, fields.txtBankCurrency, fields.txtTaxIDNumber, fields.txtAccountReceivableContactName, fields.txtAccountReceivableContactPhone, fields.txtAccountReceivableContactEmail, fields.txtAccountReceivableContactACHEmailRemittance],
            },
            {
                name: fields.txtBankName,
                displayName: "Bank Name",
                editorTemplate: "TextField",
                defaultValue: "Wells Fargo Bank, N.A.",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankAddress,
                displayName: "Bank Address",
                editorTemplate: "TextField",
                defaultValue: "420 Montgomery San Francisco, CA 94104",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankPhone,
                displayName: "Bank Phone",
                editorTemplate: "TextField",
                defaultValue: "+1-(805) 278-7442",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankContactName,
                displayName: "Bank Contact",
                editorTemplate: "TextField",
                defaultValue: "Alejandra Zamora",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankContactEmail,
                displayName: "Bank Contact Email",
                editorTemplate: "TextField",
                defaultValue: "alejandra.zamora@wellsfargo.com",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankAccountName,
                displayName: "Bank Account Name",
                editorTemplate: "TextField",
                defaultValue: "TestEquity LLC",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankAccountNumber,
                displayName: "Bank Account Number",
                editorTemplate: "TextField",
                defaultValue: "4625929328",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankSwift,
                displayName: "SWIFT",
                editorTemplate: "TextField",
                defaultValue: "WFBIUS6S",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankARBRounting,
                displayName: "ABA/Routing#",
                editorTemplate: "TextField",
                defaultValue: "121000248",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtBankCurrency,
                displayName: "Currency",
                editorTemplate: "TextField",
                defaultValue: "USD",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtTaxIDNumber,
                displayName: "TESTEQUITY Tax ID Number",
                editorTemplate: "TextField",
                defaultValue: "65-1261392",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtAccountReceivableContactName,
                displayName: "Accounts Receivable Contact Name",
                editorTemplate: "TextField",
                defaultValue: "Jane Turner",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtAccountReceivableContactPhone,
                displayName: "Accounts Receivable Contact Phone",
                editorTemplate: "TextField",
                defaultValue: "+1 (978) 974-1254",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtAccountReceivableContactEmail,
                displayName: "Accounts Receivable Contact Email",
                editorTemplate: "TextField",
                defaultValue: "jane.turner@testequity.com",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },
            {
                name: fields.txtAccountReceivableContactACHEmailRemittance,
                displayName: "ACH Email Remittance",
                editorTemplate: "TextField",
                defaultValue: "ar@testequity.com",
                fieldType: "General",
                isVisible: item => item.fields.checkboxFieldValue,
            },

        ],
    },
};
export default widgetModule;